import styled, { css } from "styled-components";
import TextAtm from "../../../../atoms/TextAtm";
var PromoText = styled(TextAtm).withConfig({
  componentId: "sc-1seubko-0"
})(function (_ref) {
  var $isAlignRight = _ref.$isAlignRight;
  return css(["text-align:right;", ""], !$isAlignRight ? css(["text-align:left;"]) : undefined);
});
export default PromoText;